import React, { useCallback, useRef, useState } from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";

const cn = (...inputs) => twMerge(clsx(inputs));

/**
 * One line of text that ends in "…" when it does not fit, with the full text in a
 * tooltip on hover. The tooltip only appears when the text was actually cut off.
 */
const TruncatedText = ({ text, className, placeholder = "—" }) => {
  const ref = useRef(null);
  const [isCut, setIsCut] = useState(false);
  const value = text == null || text === "" ? "" : String(text);

  const measure = useCallback(() => {
    const el = ref.current;
    if (el) setIsCut(el.scrollWidth > el.clientWidth);
  }, []);

  if (!value) {
    return <span className={cn("text-sm text-gray-400 dark:text-gray-500", className)}>{placeholder}</span>;
  }

  // The tooltip wraps its trigger in an inline-flex box whose width would be the whole
  // text (its min-content), so nothing ever cut off. Forcing that box to the column's
  // width lets the inner span shrink and end in "…".
  return (
    <span className="block min-w-0 max-w-full [&>div]:flex [&>div]:w-full [&>div]:max-w-full [&>div]:min-w-0">
      <CustomCommonTooltip content={isCut ? value : ""}>
        <span ref={ref} onMouseEnter={measure} className={cn("block min-w-0 truncate", className)}>
          {value}
        </span>
      </CustomCommonTooltip>
    </span>
  );
};

export default TruncatedText;
